<script>
import GenericButtonCta from "./GenericButtonCta.vue"

export default {
    name: "XdslLineIntention",
    components: { GenericButtonCta },
    props: {
        intentionsFromJson: {
            type: String,
            required: false,
            default: ""
        },
        intentionsFromObject: {
            type: Array,
            required: false,
            default: undefined
        },
        parentContainerId: {
            type: String,
            required: false,
            default: ""
        }
    },
    computed: {
        /**
         * @returns {List<XdslLineIntentionDto>}
         */
        intentions() {
            return typeof this.intentionsFromObject === "object" && this.intentionsFromObject || JSON.parse(this.intentionsFromJson)
        }
    }
}
</script>

<template>
    <div>
        <div
            v-for="(intention, intentionIndex) in intentions"
            :key="parentContainerId + ((parentContainerId) ? '-' : '') + 'xdsl-line-intention-' + intentionIndex"
        >
            <div class="col-12 px-0 fw-bold">
                {{ intention.title }}
            </div>
            <div class="col-12 px-0">
                {{ intention.description }}
            </div>
            <div class="pt-2 pb-4">
                <generic-button-cta
                    :dto-from-object="intention.genericButtonCta"
                    :css-classes="'btn-secondary'"
                />
            </div>
        </div>
    </div>
</template>
